module.exports = __webpack_public_path__ + "img/hohlschnitt_beige_ohneral.84aecb6b.jpg";